import React, { useState, useEffect } from 'react';
import styles from './Attendance.module.css';
import { stages } from '../../../data/studentsData';
import apiClient from '../../../api/client';
import { getCairoToday } from '../../../utils/cairoDate';

const Attendance = () => {
  const [selectedDate, setSelectedDate] = useState(getCairoToday());
  const [selectedStage, setSelectedStage] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');

  const [students, setStudents] = useState([]);
  const [groups, setGroups] = useState([]);
  const [attendanceData, setAttendanceData] = useState({});
  const [reportData, setReportData] = useState([]);

  // 1. جلب قائمة الطلاب والمجموعات عند فتح الصفحة
  useEffect(() => {
    apiClient.get('/students')
      .then(res => setStudents(res.data))
      .catch(err => console.error("Error fetching students:", err));

    apiClient.get('/groups')
      .then(res => setGroups(res.data))
      .catch(err => console.error("Error fetching groups:", err));
  }, []);

  // 2. جلب التقرير عند تغيير التاريخ
  useEffect(() => {
    apiClient.get(`/attendance?date=${selectedDate}`)
      .then(res => setReportData(res.data))
      .catch(err => console.error("Error fetching report:", err));
  }, [selectedDate]);

  const filteredGroups = selectedStage
    ? groups.filter(g => g.stage === selectedStage)
    : groups;

  const filteredStudents = students.filter(student => {
    const matchStage = selectedStage ? student.grade === selectedStage : true;
    const matchGroup = selectedGroup ? student.group === groups.find(g => g._id === selectedGroup)?.name : true;
    return matchStage && matchGroup;
  });

  const handleStatusChange = (studentId, status) => {
    setAttendanceData(prev => ({
      ...prev,
      [studentId]: status
    }));
  };

  const handleSaveAttendance = async () => {
    const attendanceList = Object.keys(attendanceData).map(studentId => ({
      student: studentId,
      status: attendanceData[studentId] === 'حاضر' ? 'present' : 'absent',
      date: selectedDate
    }));

    try {
      await apiClient.post('/attendance', attendanceList);
      alert("تم حفظ كشف الحضور بنجاح! 🎉");
      // تحديث التقرير بعد الحفظ مباشرة
      const { data } = await apiClient.get(`/attendance?date=${selectedDate}`);
      setReportData(data);
    } catch (error) {
      console.error("Error saving attendance:", error);
      alert("مشكلة في الاتصال بالسيرفر!");
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>تسجيل الحضور والغياب</h1>
        <button
          className={styles.saveBtn}
          onClick={handleSaveAttendance}
          disabled={Object.keys(attendanceData).length === 0}
        >
          حفظ كشف الغياب
        </button>
      </div>

      <div className={styles.filtersContainer}>
        <div className={styles.filterField}>
          <label className={styles.filterLabel}>التاريخ</label>
          <input
            type="date"
            className={styles.dateInput}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>

        <div className={styles.filterField}>
          <label className={styles.filterLabel}>المرحلة الدراسية</label>
          <select
            className={styles.selectBox}
            value={selectedStage}
            onChange={(e) => {
              setSelectedStage(e.target.value);
              setSelectedGroup('');
            }}
          >
            <option value="">اختر المرحلة الدراسية</option>
            {stages.map((stage, index) => (
              <option key={index} value={stage}>{stage}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterField}>
          <label className={styles.filterLabel}>المجموعة</label>
          <select
            className={styles.selectBox}
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            disabled={!selectedStage}
          >
            <option value="">اختر المجموعة لفتح الكشف</option>
            {filteredGroups.map(group => (
              <option key={group._id} value={group._id}>
                {group.name} - {group.time}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* جدول التسجيل */}
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>كود الطالب</th>
              <th>الاسم</th>
              <th>حالة الحضور</th>
            </tr>
          </thead>
          <tbody>
            {filteredStudents.length > 0 ? (
              filteredStudents.map(student => (
                <tr key={student._id}>
                  <td>{student.code}</td>
                  <td>{student.name}</td>
                  <td>
                    <div className={styles.actionBtns}>
                      <button
                        className={`${styles.statusBtn} ${styles.btnPresent} ${attendanceData[student._id] === 'حاضر' ? styles.active : ''}`}
                        onClick={() => handleStatusChange(student._id, 'حاضر')}
                      >حاضر</button>
                      <button
                        className={`${styles.statusBtn} ${styles.btnAbsent} ${attendanceData[student._id] === 'غائب' ? styles.active : ''}`}
                        onClick={() => handleStatusChange(student._id, 'غائب')}
                      >غائب</button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: 'center', padding: '2rem' }}>
                  {selectedStage ? "الرجاء اختيار المجموعة" : "الرجاء اختيار المرحلة والمجموعة"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* جدول عرض التقرير */}
      <div className={styles.tableContainer} style={{ marginTop: '50px' }}>
        <h2 className={styles.title}>تقرير يوم {selectedDate}</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>اسم الطالب</th>
              <th>الحالة</th>
            </tr>
          </thead>
          <tbody>
            {reportData.length > 0 ? (
              reportData.map(item => (
                <tr key={item._id}>
                  <td>{item.student?.name || "طالب محذوف"}</td>
                  <td>
                    <span className={item.status === 'present' ? styles.statusActive : styles.statusAbsent}>
                      {item.status === 'present' ? 'حاضر' : 'غائب'}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" style={{ textAlign: 'center' }}>لا توجد بيانات حضور لهذا اليوم</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Attendance;
